import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import '../timeSheet.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

function FilesTimesheet() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showApprove, setshowApprove] = useState(false);
    const handleClose = () => setShow(false);
    const handleCloseApprove = () => setshowApprove(false);

return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{ xs:12 }} container justifyContent="space-between" alignItems="center">
                    <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Timesheet Management</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Timesheet Management</span>
                    </Grid>
                    <button className='back_buttonminus mb-0' onClick={() => navigate(-1)}>Back</button>
                </Grid>
                <Grid size={{ xs: 12 }} container justifyContent="space-between" alignItems="center" className="mt-5">
                    <Grid size={{ sm:6,xs: 12 }} container className="gap-3">
                        <h4 className='fw-semibold' style={{color:"#C42B7D"}}>HR Training</h4>
                    </Grid>
                    <Grid container>
                        <div className='profile_show'>
                            <img src={require("../../../assets/defaultprofile.svg").default} alt=''/>
                            <div className='profile_sheet_content'>
                                <span className='my-0'>Matthew Johnson</span>
                                <small>EMPLID002345</small>
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container className="mt-4 timesheet_table timesheet_subadmin">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                            <th>FILE</th>
                            <th>DATE</th>
                            <th>TIME</th>
                            </tr>
                        </thead>
                        <tbody className='tablerow_oddone'>
                            <tr>
                            <td className='text-start'>
                                <span className='files_showtable'>File Name 1245.pdf</span>
                            </td>
                            <td className='text-start'>
                                12/01/2024
                            </td>
                            <td className='text-start'>10:00 AM</td>
                            </tr>
                        </tbody>
                    </table>
                </Grid>
            </Grid>
            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body>
                <Grid size={{xs:12}} container flexDirection="column" className="regiter_inputs i94validateinput">
                    <span className='mt-0'>Reason for rejection</span>
                    <textarea placeholder='Write points' className='sheet_resontextarea'/>
                    <Grid size={{xs:12}} container justifyContent="flex-end" className="gap-3">
                        <button className='registersendbtn1 mb-2' onClick={handleClose}>
                            Cancel
                        </button>
                        <button className='registersendbtn2 mb-2'>Submit</button>
                    </Grid>
                </Grid>
                </Modal.Body>
            </Modal>
            <Modal
                show={showApprove}
                onHide={handleCloseApprove}
                size="md"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body>
                    <Grid size={{xs:12}} container>
                        <Grid size={{xs:12}} container flexDirection="column" alignItems="center" className="approve_mainsheetmodal">
                            <FontAwesomeIcon className='approve_icon mb-3' icon={faCircleCheck} />
                            <h4>Approve Timesheet</h4>
                            <span>are you sure want to approve this timesheet</span>
                        </Grid>
                        <Grid size={{xs:12}} container justifyContent="center" className="gap-3 approve_mainsheetmodal">
                            <button className='registersendbtn1 mb-2' onClick={handleCloseApprove}>
                                No
                            </button>
                            <button className='registersendbtn2 mb-2'>Yes</button>
                        </Grid>
                    </Grid>
                </Modal.Body>
            </Modal>
        </div>
    </div>
  );
}

export default FilesTimesheet;